import React from "react";
import { Clock } from "lucide-react";
import { SCHEDULE_STRINGS } from "../constants/strings";
import { Spinner } from "../ui";
import "./TimeSlotPicker.css";

export default function TimeSlotPicker({
  slots = [],
  selectedSlot,
  onSelect,
  isLoading = false,
  emptyMessage = SCHEDULE_STRINGS.NO_SLOTS,
}) {
  if (isLoading) {
    return (
      <div className="tsp-loading">
        <Spinner size={22} />
      </div>
    );
  }

  if (slots.length === 0) {
    return <p className="tsp-empty">{emptyMessage}</p>;
  }

  return (
    <div className="tsp-grid">
      {slots.map((slot) => {
        const isSelected = selectedSlot?.dateTime === slot.dateTime;
        return (
          <button
            key={slot.dateTime}
            type="button"
            className={`tsp-slot ${isSelected ? "tsp-slot-on" : ""}`}
            onClick={() => onSelect(slot)}
          >
            <Clock size={12} />
            <span>{slot.startTime} - {slot.endTime}</span>
          </button>
        );
      })}
    </div>
  );
}
